import { InjectionToken } from '@angular/core';
import { Client, Transport } from '@connectrpc/connect';
import { AuthData } from '@gen/src/protos/auth/v1/auth_pb';
import { UserData } from '@gen/src/protos/users/users_pb';
import { CatalogData } from '@gen/src/protos/catalogs/catalog_pb';

export const AUTH_CLIENT = new InjectionToken<Client<typeof AuthData>>('AuthClient');
export const USER_CLIENT = new InjectionToken<Client<typeof UserData>>('UserClient');
export const CATALOG_CLIENT = new InjectionToken<Client<typeof CatalogData>>('CatalogClient');
export const GRPC_TRANSPORT = new InjectionToken<Transport>('GRPC_TRANSPORT');
export const GRPC_CATALOG_TRANSPORT = new InjectionToken<Transport>('GRPC_CATALOG_TRANSPORT');
